module.exports = __webpack_public_path__ + "img/row-srp-preview-mitsu.30c871c4.png";